import { Authenticator, useAuthenticator } from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css"; // eslint-disable-line import/no-unresolved, import/extensions
import React from "react";
import { useDispatch } from "react-redux";
import { HashRouter } from "react-router-dom";
import { Amplify } from "aws-amplify"; // eslint-disable-line

import awsconfig from "./aws-exports";
import { cognitoGroup } from "./common/AppConstant";
import Base from "./component/base/Base";
import BaseServiceMan from "./component/base/BaseServiceMan";
import { fetchUpdateUserInfo } from "./store/AuthStore";

Amplify.configure(awsconfig);

/**
 * Appコンポーネント.
 *
 * @return {object} コンポーネント
 */
function App() {
  // 認証状態State
  const [authState, setAuthState] = React.useState();
  // ユーザー情報State
  const [userInfo, setUserInfo] = React.useState();

  // サービスマン情報State
  const [isServiceMan, setIsServiceManInfo] = React.useState(false);

  // Dispatch
  const dispatch = useDispatch();

  // Get authentication state from the hook
  const { authStatus, user } = useAuthenticator((context) => [
    context.authStatus,
    context.user,
  ]);

  // 副作用
  React.useEffect(() => {
    setAuthState(authStatus);
    setUserInfo(user);
  }, [authStatus, user]);

  // 副作用
  React.useEffect(() => {
    if (
      userInfo &&
      userInfo.signInUserSession &&
      userInfo.signInUserSession.idToken &&
      userInfo.signInUserSession.idToken.payload &&
      userInfo.signInUserSession.idToken.payload["cognito:groups"]
    ) {
      const groups =
        userInfo.signInUserSession.idToken.payload["cognito:groups"];
      const userName =
        userInfo.signInUserSession.idToken.payload["cognito:username"];
      const payload = {
        groups,
        userName,
      };
      setIsServiceManInfo(false);
      if (groups.includes(cognitoGroup.serviceMan)) {
        setIsServiceManInfo(true);
      }
      dispatch(fetchUpdateUserInfo(payload));
    }
  }, [dispatch, userInfo]);

  return authState === "authenticated" && userInfo ? (
    <HashRouter>{isServiceMan ? <BaseServiceMan /> : <Base />}</HashRouter>
  ) : (
    <Authenticator hideSignUp />
  );
}

export default App;
